import template from './providerInfo.html';
import controller from './providerInfoCtrl.js';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
